import { Navigate, useLocation } from 'react-router-dom'
import { employeeServices } from '@services'
import { ROUTES } from '@common'

/**
 * EmployeeProtectedRoute component
 * Protects routes that require employee authentication
 * Redirects to login page if no valid token is found
 */
export default function EmployeeProtectedRoute({ children }) {
    const location = useLocation()
    const tokens = employeeServices.getEmployeeTokens()

    // Check if token exists and is not expired
    const isAuthenticated =
        tokens.accessToken && tokens.accessToken.trim() !== '' && tokens.expiredAt && new Date(tokens.expiredAt) > new Date()

    if (!isAuthenticated) {
        // Redirect to login page, preserving the intended destination
        return <Navigate to={ROUTES.CheckoutAssistant.login} state={{ from: location }} replace />
    }

    return children
}
